import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ctaClick } from 'store/booking/bookingActions';

const useCtaClickEvent = () => {
  const dispatch = useDispatch();

  const ctaClickEvent = useCallback(
    ({ itemText, itemType, url }) => {
      dispatch(
        ctaClick({
          itemText,
          itemType,
          url,
        }),
      );
    },
    [dispatch],
  );

  return { ctaClickEvent };
};

export default useCtaClickEvent;
